Vehicle = function() { Model.call(this); };

Vehicle.prototype             = new Vehicle();
Vehicle.prototype.constructor = Vehicle;

Vehicle.prototype.get_infos = function(vehicle_id, callbacks)
{
    this.ajax({
        url:       'vehicle/index/'+vehicle_id,
        type:      'GET',
        dataType:  'json',
        callbacks: callbacks
    });
};

Vehicle.prototype.get_photos = function(file_number, recycler_code, callbacks)
{
    this.ajax({
        url:       'vehicle/photos/'+file_number+'/'+recycler_code,
        type:      'GET',
        dataType:  'json',
        callbacks: callbacks
    });
};
